// extracted by mini-css-extract-plugin
export default {"customTooltip":"BarChart_customTooltip__2pwde","title":"BarChart_title__GCiJi","labelX":"BarChart_labelX__ALA41","labelY":"BarChart_labelY__gJI4S"};